import { render, staticRenderFns } from "./session-breadcrumbs.vue?vue&type=template&id=27e84b44&scoped=true&"
import script from "./session-breadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./session-breadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./session-breadcrumbs.vue?vue&type=style&index=0&id=27e84b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e84b44",
  null
  
)

export default component.exports